import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { PiBarcodeLight } from "react-icons/pi";
// import CountdownTimer from "./countdown";
import { IoCloseOutline } from "react-icons/io5";
import TicketDetails from "./ticketdetails";
import TranSel from "./transel";
import { useAuth } from "../context/AuthContext"; // Adjust path as needed
import { FaArrowAltCircleRight } from "react-icons/fa";
import CancelTfMail from "./canceltfmail";
import AuthoPage from "./authopage";
import MyMap from "./map";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import Barcode from "./barcode";
import { MdOutlineInfo } from "react-icons/md";

dayjs.extend(duration);

export default function EventDetails({ chatData, onClose }) {
  const { user } = useAuth();
  const [showDetails, setShowDetails] = useState(false);
  const [showTrans, setShowTrans] = useState(false);
  const [showAutho, setShowAutho] = useState(false);
  const [showBarcode, setShowBarcode] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState("ticket");
  const [selectedSeatNumber, setSelectedSeatNumber] = useState(null);

  const tabs = [
    { key: "ticket", label: `MY TICKETS ${chatData?.num_seats}` },
    { key: "order", label: "ADD-ONS" },
  ];

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  function formatDateTime(dateStr, timeStr) {
    const dateTime = new Date(`${dateStr}T${timeStr}`);

    const weekday = dateTime.toLocaleString("en-US", { weekday: "short" });
    const month = dateTime.toLocaleString("en-US", { month: "short" });
    const day = dateTime.getDate();
    const time = dateTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${weekday}, ${month} ${day}, ${time}`;
  }

  const numSeats = parseInt(chatData?.num_seats) || 0;
  const startSeat = parseInt(chatData?.seat_no) || 1;
  const seats = Array.from({ length: numSeats }, (_, i) => startSeat + i);

  const seatCount = chatData?.trans_seats
    ? chatData.trans_seats.split(",").length
    : 0;

  const [timeLeft, setTimeLeft] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  useEffect(() => {
    if (!chatData?.event_date || !chatData?.event_time || !chatData?.timer)
      return;

    const eventDateTime = dayjs(
      `${chatData.event_date}T${chatData.event_time}`
    );
    const countdownTarget = eventDateTime.subtract(chatData.timer, "hour");

    const updateCountdown = () => {
      const now = dayjs();
      const diff = countdownTarget.diff(now);

      if (diff <= 0) {
        setTimeLeft({ days: "00", hours: "00", minutes: "00", seconds: "00" });
        return;
      }

      const dur = dayjs.duration(diff);

      setTimeLeft({
        days: String(Math.floor(dur.asDays())).padStart(2, "0"),
        hours: String(dur.hours()).padStart(2, "0"),
        minutes: String(dur.minutes()).padStart(2, "0"),
        seconds: String(dur.seconds()).padStart(2, "0"),
      });
    };

    updateCountdown(); // run immediately
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [chatData]);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{ height: "100%" }}
    >
      <div>
        {/* HEADER & TABS */}
        <div style={{ backgroundColor: "rgb(22, 19, 22)" }}>
          <div className="flex items-center justify-between w-full pt-2 pb-2 pl-4 pr-4">
            <div className="flex justify-start">
              <button className=" text-gray-200" onClick={handleClose}>
                <IoCloseOutline size={33} />
              </button>
            </div>
            <div className="mx-auto">
              <div className="flex items-center justify-center gap-1">
                <p className="text-md font-medium text-gray-200">My Tickets</p>
              </div>
            </div>
            <p className="text-md font-medium text-gray-200">Help</p>
          </div>
        </div>

        <div className="flex w-full bg-blue-700 tabs-bar">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`tab-item px-4 py-4 text-xs text-center w-full font-medium relative ${
                activeTab === tab.key ? "text-gray-200" : "text-gray-300"
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
              {activeTab === tab.key && (
                <div className="absolute bottom-0 left-0 right-0 h-1 underline bg-white shadow-md rounded-t-md" />
              )}
            </div>
          ))}
        </div>

        {/* Swiper */}
        <Swiper
          pagination={{ clickable: true }}
          modules={[Pagination]}
          slidesPerView={1}
          spaceBetween={20}
          className="w-full h-84 mt-1"
          style={{
            paddingRight: "35px", // 👈 adds space after last slide
            paddingLeft: "35px",
            paddingBottom: "35px", // 👈 creates space below for pagination
          }}
        >
          {seats.map((seatNumber) => (
            <SwiperSlide key={seatNumber}>
              {/* <div className="p-2 pb-5 w-full bg-blue-600 rounded-t-xl"> */}
              <div
                className={`p-2 pb-5 w-full rounded-t-xl ${
                  chatData?.transfer === "yes"
                    ? chatData?.trans_seats
                        ?.split(",")
                        .map((num) => num.trim())
                        .includes(String(seatNumber))
                      ? "bg-slate-500"
                      : "bg-blue-600"
                    : "bg-blue-600"
                }
                }`}
              >
                <div className="text-center items-center pl-5 text-gray-200 flex">
                  <p className="text-center text-xs mx-auto">
                    {chatData?.ticket_type}
                  </p>
                  <MdOutlineInfo size={22} />
                </div>

                {chatData?.seat_no === "0" && user?.ga_design === "D2" ? (
                  <div>
                    <div className="text-center text-md font-medium mt-1 text-gray-200">
                      General Admission
                    </div>
                    <div className="flex justify-around mt-3">
                      <div className="flex flex-col align-center text-center flex-1">
                        <p className="text-xl text-gray-100 font-semibold">
                          {chatData?.section}
                        </p>
                      </div>

                      <div className="flex flex-col align-center text-center flex-1">
                        <p className="text-xl text-gray-100 font-semibold">
                          {chatData?.row}
                        </p>
                      </div>

                      <div className="flex flex-col align-center text-center flex-1">
                        <p className="text-xl text-gray-100 font-semibold">-</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex justify-around mt-8">
                    {/* <div className="flex flex-col align-center text-center ${user?.ga_design === 'D1'} ? '' : 'flex-1'"> */}
                    <div
                      className={`flex flex-col align-center text-center ${
                        chatData?.seat_no === "0" && user?.ga_design === "D1"
                          ? ""
                          : "flex-1"
                      }`}
                    >
                      <p className="text-xs text-gray-100 font-thin">SEC</p>
                      <p className="text-lg text-gray-100 font-semibold">
                        {chatData?.section}
                      </p>
                    </div>

                    {chatData?.seat_no === "0" && user?.ga_design !== "D2" ? (
                      ""
                    ) : (
                      <div className="flex flex-col align-center text-center flex-1">
                        <p className="text-xs text-gray-100 font-thin">ROW</p>
                        <p className="text-lg text-gray-100 font-semibold">
                          {chatData?.row}
                        </p>
                      </div>
                    )}

                    {chatData?.seat_no === "0" && user?.ga_design !== "D2" ? (
                      <div>
                        <p className="text-gray-100 text-lg font-semibold mt-1">
                          General Admission
                        </p>
                      </div>
                    ) : (
                      <div className="flex flex-col align-center text-center flex-1">
                        <p className="text-xs text-gray-100 font-thin">SEAT</p>
                        <p className="text-lg text-gray-100 font-semibold">
                          {seatNumber}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="w-full">
                <div
                  className="w-full h-44 bg-cover bg-center relative"
                  style={{ backgroundImage: `url(${chatData?.image_url})` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent pointer-events-none"></div>
                  <div className="absolute inset-0 z-10 flex flex-col justify-end px-1 pb-1 pointer-events-none">
                    <h2 className="text-gray-200 text-center text-lg leading-6">
                      {chatData?.event_name}
                    </h2>
                    <p className="text-xs text-gray-300 text-center pt-2 truncate">
                      {chatData?.event_date && chatData?.event_time
                        ? formatDateTime(
                            chatData.event_date,
                            chatData.event_time
                          )
                        : "Date not available"}{" "}
                      • {chatData?.event_venue}
                    </p>
                  </div>

                  {chatData?.transfer === "yes" ? (
                    chatData?.trans_seats
                      ?.split(",")
                      .map((num) => num.trim())
                      .includes(String(seatNumber)) ? (
                      <div className="absolute inset-0 flex items-center justify-center">
                        {chatData?.tf_des === "sent" ? (
                          <FaArrowAltCircleRight
                            size={70}
                            className="text-gray-100"
                            onClick={() => {
                              setShowAutho(true);
                            }}
                          />
                        ) : (
                          <img
                            src="../images/circlecheck.png"
                            alt=""
                            className="w-20"
                            onClick={() => {
                              setShowAutho(true);
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {chatData?.transfer === "yes" ? (
                chatData?.trans_seats
                  ?.split(",")
                  .map((num) => num.trim())
                  .includes(String(seatNumber)) ? (
                  <div
                    className={`text-center py-1 ${
                      chatData?.tf_des === "sent"
                        ? "bg-blue-600"
                        : "bg-green-500"
                    } text-gray-200`}
                  >
                    <p className="text-xs">
                      {chatData?.tf_des === "claimed" ? "Claimed" : "Sent"}
                    </p>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}

              <div className="border w-full border-gray-300 rounded-b-xl">
                {chatData?.transfer === "yes" ? (
                  chatData?.trans_seats
                    ?.split(",")
                    .map((num) => num.trim())
                    .includes(String(seatNumber)) ? (
                    chatData?.tf_des === "sent" ? (
                      <div className="flex flex-col items-center pt-5 pb-7">
                        <div className="mb-2 mt-2 text-center">
                          <p className="text-sm font-semibold text-gray-800">
                            {seatCount} {seatCount > 1 ? "tickets" : "ticket"}{" "}
                            sent to
                          </p>
                          <p className="text-sm font-medium text-gray-800 mt-2">
                            {chatData?.tf_fname} {chatData?.tf_lname}
                          </p>
                          <p className="text-sm font-medium text-gray-800 ">
                            Waiting for recipient to claim.
                          </p>
                        </div>

                        <CancelTfMail />
                      </div>
                    ) : (
                      <div className="flex flex-col items-center pt-12 pb-12">
                        <div className="mb-2 mt-2 text-center">
                          <p className="text-sm font-semibold text-gray-800">
                            {seatCount} {seatCount > 1 ? "tickets" : "ticket"}{" "}
                            claimed by
                          </p>
                          <p className="text-sm font-medium text-gray-800 mt-1">
                            {chatData?.tf_fname} {chatData?.tf_lname}
                          </p>
                          <p className="text-sm font-medium mt-1 text-gray-800 ">
                            {chatData?.order_num}
                          </p>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="flex flex-col items-center pt-8 pb-12">
                      <div className="mb-4 mt-2">
                        <p className="text-sm font-medium text-gray-800">
                          {chatData?.entry_info}
                        </p>
                      </div>
                      <div className="w-10/12 bg-blue-700 flex justify-center">
                        <button
                          onClick={() => {
                            setSelectedSeatNumber(seatNumber);
                            setShowBarcode(true);
                          }}
                          className="text-lg text-gray-200 bg-blue-700 flex justify-center align-center items-center p-2 gap-2"
                        >
                          <PiBarcodeLight size={23} />
                          <p className="tracking-wider text-xs">View Ticket</p>
                        </button>
                      </div>
                      <div className="mt-5">
                        <p
                          onClick={() => {
                            setSelectedSeatNumber(seatNumber);
                            setShowDetails(true);
                          }}
                          className="text-sm text-blue-600 font-medium"
                        >
                          Ticket Details
                        </p>
                      </div>
                    </div>
                  )
                ) : chatData?.timer === "0" ? (
                  <div className="flex flex-col items-center pt-8 pb-12">
                    <div className="mb-4 mt-2">
                      <p className="text-sm font-medium text-gray-800">
                        {chatData?.entry_info}
                      </p>
                    </div>
                    <div className="w-10/12 bg-blue-700 flex justify-center">
                      <button
                        onClick={() => {
                          setSelectedSeatNumber(seatNumber);
                          setShowBarcode(true);
                        }}
                        className="text-lg text-gray-200 bg-blue-700 flex justify-center align-center items-center p-2 gap-2"
                      >
                        <PiBarcodeLight size={23} />
                        <p className="tracking-wider text-xs">View Ticket</p>
                      </button>
                    </div>
                    <div className="mt-5">
                      <p
                        onClick={() => {
                          setSelectedSeatNumber(seatNumber);
                          setShowDetails(true);
                        }}
                        className="text-sm text-blue-600 font-medium"
                      >
                        Ticket Details
                      </p>
                    </div>
                  </div>
                ) : (
                  //countdown timer here
                  <div className="flex flex-col items-center pt-8 pb-9">
                    <div>
                      <p className="text-xs font-medium mb-1">
                        Ticket will be ready in:
                      </p>
                    </div>
                    <div className="flex gap-8 mb-4">
                      <div className="flex flex-col text-center">
                        <p className="font-medium text-3xl mb-1">
                          {timeLeft.days}
                        </p>
                        <p style={{ fontSize: "0.65rem" }}>DAY</p>
                      </div>

                      <div className="flex flex-col text-center">
                        <p className="font-medium text-3xl mb-1">
                          {timeLeft.hours}
                        </p>
                        <p style={{ fontSize: "0.65rem" }}>HOUR</p>
                      </div>

                      <div className="flex flex-col text-center">
                        <p className="font-medium text-3xl mb-1">
                          {timeLeft.minutes}
                        </p>
                        <p style={{ fontSize: "0.65rem" }}>MIN</p>
                      </div>

                      <div className="flex flex-col text-center">
                        <p className="font-medium text-3xl mb-1">
                          {timeLeft.seconds}
                        </p>
                        <p style={{ fontSize: "0.65rem" }}>SECONDS</p>
                      </div>
                    </div>

                    <div className="mt-9">
                      <p
                        onClick={() => {
                          setSelectedSeatNumber(seatNumber);
                          setShowDetails(true);
                        }}
                        className="text-sm text-blue-600 font-semibold"
                      >
                        Ticket Details
                      </p>
                    </div>
                  </div>
                )}

                <div className="w-full flex justify-center">
                  <div
                    // className="w-11/12 border-b border-blue-700"
                    className={`w-11/12 border-b ${
                      chatData?.transfer === "yes"
                        ? chatData?.trans_seats
                            ?.split(",")
                            .map((num) => num.trim())
                            .includes(String(seatNumber))
                          ? "border-slate-600"
                          : "border-blue-700"
                        : "border-blue-700"
                    }
                  }`}
                  ></div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex gap-4 px-7 text-center mt-2">
          <div
            onClick={() => setShowTrans(true)}
            className={` ${
              user?.tf_button === "no"
                ? "opacity-30 bg-gray-600"
                : "bg-blue-600"
            } flex-1 px-4 py-3 text-sm text-gray-200 rounded-md`}
          >
            <p>Transfer</p>
          </div>
          <div className="bg-gray-600 opacity-30 px-4 py-3 flex-1 text-sm text-gray-200 rounded-md">
            Sell
          </div>
          <div
            className={`bg-blue-600 ${
              user?.order_btn === "no" ? "hidden" : ""
            } px-4 py-3 text-sm flex-1 text-gray-200 rounded-md`}
          >
            Orders
          </div>
        </div>
      </div>

      {showDetails && selectedSeatNumber !== null && (
        <TicketDetails
          chatData={chatData}
          seatNumber={selectedSeatNumber}
          OnClose={() => {
            setShowDetails(false);
            setSelectedSeatNumber(null);
          }}
        />
      )}

      {showBarcode && selectedSeatNumber !== null && (
        <Barcode
          chatData={chatData}
          seatNumber={selectedSeatNumber}
          OnClose={() => {
            setShowBarcode(false);
            setSelectedSeatNumber(null);
          }}
        />
      )}

      {/* transfer here */}
      {showTrans && (
        <TranSel
          chatData={chatData}
          OnClose={() => {
            setShowTrans(false);
          }}
        />
      )}

      {/* authorization page here */}
      {showAutho && (
        <AuthoPage
          OnClose={() => {
            setShowAutho(false);
          }}
        />
      )}

      {/* map component here */}

      {user?.map_box === "yes" ? (
        <div className="px-2 mt-4">
          <div className="w-full overflow-hidden rounded-2xl border border-gray-300 relative z-10">
            <MyMap />
          </div>
        </div>
      ) : (
        " "
      )}
    </div>
  );
}
